import type { IconSvgObject } from './types';

const Home08Icon: IconSvgObject = [
  ["path", { d: "M4 8.99957V14.5004C4 17.8002 4 19.4501 5.02513 20.4753C6.05025 21.5004 7.70017 21.5004 11 21.5004H13C16.2998 21.5004 17.9497 21.5004 18.9749 20.4753C20 19.4501 20 17.8002 20 14.5004V8.99957", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M21.5 9.99957L15.865 4.97135C14.0183 3.3235 13.095 2.49957 12 2.49957C10.905 2.49957 9.98167 3.3235 8.13497 4.97135L2.5 9.99957", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M11.9993 14.4996V21.4996", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default Home08Icon;
